import { DynamicDecorator } from '@natu/ui/Decorators/DynamicDecorator';
import { cn } from '@natu/utils/cn';

import {
  type BlokItem,
  DynamicRender,
  getLinkPropsFromStoryblok,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
  type StoryblokLink,
} from '../../../../utils';
import { CoreWebVitalsContent } from './CoreWebVitalsContent';

interface SBCoreWebVitalsProps {
  heading?: string;
  subheading?: string;
  badScore?: string;
  notBadScore?: string;
  greatScore?: string;
  buttonLabel?: string;
  carousel?: BlokItem[];
  testLengthInfo?: string;
  errorMessage?: string;
  buttonUrl?: StoryblokLink;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
}

export const SBCoreWebVitals = ({ blok }: SBProps<SBCoreWebVitalsProps>) => {
  const {
    badScore,
    greatScore,
    heading,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
    notBadScore,
    subheading,
    buttonLabel,
    buttonUrl,
    carousel,
    errorMessage,
    testLengthInfo,
  } = blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  const resolvedUrl = getLinkPropsFromStoryblok(buttonUrl);

  return (
    <div
      className={cn(
        className,
        'border-naturaily-azureGray shadow-3xl relative flex flex-col justify-center rounded-2xl border bg-white px-6 py-8 lg:min-h-[540px]',
      )}
      {...sbEditable(blok)}
    >
      <CoreWebVitalsContent
        buttonLabel={buttonLabel}
        heading={heading}
        notBadScore={notBadScore}
        resolvedUrl={resolvedUrl}
        subheading={subheading}
        badScore={badScore}
        greatScore={greatScore}
        errorMessage={errorMessage}
        testLengthInfo={testLengthInfo}
        carousel={<DynamicRender data={carousel} />}
      />

      <DynamicDecorator
        decorator="quadrant"
        className="absolute left-9 top-6 hidden h-auto w-11 text-gray-300 lg:block"
      />
      <DynamicDecorator
        decorator="circle"
        className="text-primary-600 absolute left-28 top-4 hidden h-auto w-7 lg:block"
      />
    </div>
  );
};
